<script lang="ts">
  import CustomContentCollaterals from "@shared/svelte/Components/CustomContentCollaterals/CustomContentCollaterals.svelte";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import { CustomContentCollateralSectionEntity } from "@shared/services/event_tracking/entities";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import type { CustomContentCollateral } from "@shared/types/CustomContent";

  const { trackMrcEvents } = EventTracking;

  export let mobileMode: boolean;
  export let collaterals: CustomContentCollateral[] = [];
  export let trackingData: { id: number; position: number };

  let displayIsVertical: boolean = window.innerWidth < 700;

  const trackingParams: any[] = [new CustomContentCollateralSectionEntity(trackingData)];
</script>

<TrackingContext entities={trackingParams} let:trackingContext>
  <div
    class="fizz-align-stretch"
    class:fizz-stack-16={mobileMode}
    data-testid="collateral-section"
    use:trackMrcEvents={[trackingContext.entities]}
  >
    <div class="fizz-border-top fizz-stack-8" />
    <CustomContentCollaterals
      dataTestIdBase={"collateral-section-collaterals"}
      {collaterals}
      alignCollateralRight={false}
      useMargin={false}
      bind:mobileMode
      bind:displayIsVertical
    />
    <div class="fizz-stack-8" />
    <div class="fizz-border-bottom" />
  </div>
</TrackingContext>
